import { render, staticRenderFns } from "./AddSession.vue?vue&type=template&id=2678267e"
import script from "./AddSession.vue?vue&type=script&lang=ts"
export * from "./AddSession.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports